import script from "./CustomRangeSlider.vue?vue&type=script&setup=true&lang=js"
export * from "./CustomRangeSlider.vue?vue&type=script&setup=true&lang=js"

import "./CustomRangeSlider.vue?vue&type=style&index=0&id=230db642&scoped=true&lang=css"

import exportComponent from "/Users/terrencewong/ispeech/ispeech-web-ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-230db642"]])

export default __exports__